import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { useGetCandidate } from '../../common/useGetCandidate';
import { useHeaderHeight } from '../../common/useHeaderHeight';
import { useTableDataHeight } from '../../common/useTableDataHeight';

import { RecruitmentDetailsHeader } from './RecruitmentDetailsHeader';
import { RecruitmentStatus } from './RecruitmentStatus';
import { useGetRecruitmentHistory } from './useGetRecruitmentHistory';

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  height: 100vh;
`;

export const RecruitmentDetailsPage: React.FC = () => {
  const { id } = useParams();
  const { data: recruitment, isLoading: recruitmentLoading } = useGetRecruitmentHistory(id || '');
  const { data: candidate, isLoading: candidateLoading } = useGetCandidate(recruitment?.candidateUuid || '');

  const { headerHeight, headerRef } = useHeaderHeight();

  const { tableHeight } = useTableDataHeight(headerHeight + 20 + 50 + 20 + 20, 20);

  if (recruitmentLoading || candidateLoading || !recruitment || !candidate) return <></>;

  return (
    <MainContainer>
      <RecruitmentDetailsHeader candidate={candidate} recruitment={recruitment} ref={headerRef} />
      <RecruitmentStatus recruitment={recruitment} candidate={candidate} height={tableHeight} />
    </MainContainer>
  );
};
